<template>
	<Checkbox
		:checked="checked"
		:errors="errors"
		required
		@input="onInput"
	>
		{{ $t('form.privacyAgreement.text') }}
		<a
			href="/privacy"
			target="_blank"
		>{{ $t('form.privacyAgreement.link') }}</a>
	</Checkbox>
</template>

<script>
import Checkbox from '@/components/form/Checkbox.vue';

export default {
	components: {
		Checkbox,
	},

	props: {
		value: {},
		errors: {},
	},

	computed: {
		checked: {
			get() {
				return this.value
			},
			set(v) {
				this.$emit('input', v)
			}
		}
	},

	methods: {
		onInput(e) {
			this.checked = e
		},

	},

	created() {
		this.checked = false

	},
}
</script>

<style lang="scss">
@import '@/sass/_variables';

</style>
